export const API = 'API';
// auth
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';

// userProfiles
export const FETCH_USER_PROFILES = 'FETCH_USER_PROFILES';
export const SWITCH_PROFILE = 'SWITCH_PROFILE';

export const CLEAR_AUTH = 'CLEAR_AUTH';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';